import Skeleton from "react-loading-skeleton";

import { Address } from "viem";

import { usePointsLeaderboardQuery } from "shared/api/use-points-leaderboard-query";
import { Dialog } from "shared/ui/dialog";

import { Header } from "./header";
import { Row } from "./row";

type Props = {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
};

const formatter = new Intl.NumberFormat("en-US", {
  notation: "compact",
});

export const Leaderboard = (props: Props) => {
  const { isOpen, onOpenChange } = props;

  const query = usePointsLeaderboardQuery({ enabled: isOpen });

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Content className="w-full md:max-w-4xl">
        <Dialog.Body>
          <Dialog.Title className="bg-white/2 p-4.5" showClose>
            Points Leaderboard
          </Dialog.Title>
          <div className="px-5 py-4">
            <Header />
            <ul className="flex flex-col gap-y-1.5 overflow-hidden rounded-[20px]">
              {query.isPending &&
                Array.from({ length: 10 }).map((_, index) => {
                  return <Skeleton key={index} height={52} borderRadius={10} />;
                })}
              {query.data?.map((item) => {
                return (
                  <Row
                    key={item.position}
                    position={item.position}
                    percent={item.percent}
                    account={item.account as Address}
                    points={formatter.format(item.points)}
                  />
                );
              })}
            </ul>
          </div>
        </Dialog.Body>
      </Dialog.Content>
    </Dialog>
  );
};
